<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-6">
                        <h3>REPORTE DE DESPACHOS POR PRODUCTO</h3>
                    </div>
                    <div class="col-6 text-right">
                        <button class="btn btn-primary btn-icon" @click="cargar_datos"><i class="fas fa-filter"></i> Filtrar</button>
                        <button class="btn btn-success btn-icon" @click="exportar_excel"><i class="fas fa-file-excel"></i> Excel</button>
                    </div>
                </div>

                <div class="row mt-2">
                    <div class="col">
                        <table class="table table-bordered">
                            <tr class="background-light">
                                <th>RANGO DE FECHAS</th>
                                <th>TIPO DESPACHO</th>
                                <th>PRODUCTO</th>

                            </tr>
                            <tr>
                                <td>
                                    <date-picker v-model="fechas" :range="true" format="DD-MM-YYYY" :editable="false" :clearable="true" value-type="YYYY-MM-DD"></date-picker>
                                </td>
                                <td>
                                    <!-- <select class="" name="" id="" v-model="tipo_despacho_ids" multiple>
                                        <option value="">--Sin Seleccion--</option>
                                        <option :value="item.id" v-for="item in tipo_despachos" :key="item.id">{{item.nombre}}</option>
                                    </select> -->

                                    <v-select class="" :reduce="option => option.id" v-model="tipo_despacho_ids" :closeOnSelect="false" :options="tipo_despachos" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                </td>
                                <td>
                                    <v-select style="width:360px;" class="" :reduce="option => option.id" v-model="productos_ids" :options="retornar_productos" label="producto" multiple>
                                        <template v-slot:option="option">
                                            
                                            <span style="font-weight:bold; font-size:11px;">{{option.tipo_despacho}}| </span>
                                            {{ `${option.producto}` }}
                                        </template>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select>
                                    <!-- <v-select class="" :reduce="option => option.id" v-model="empresas_id" :closeOnSelect="false" :options="proveedores" label="nombre" multiple>
                                        <template v-slot:no-options="{ search, searching }">
                                        <template v-if="searching">
                                            No se Encontraron Resultados Para <em>{{ search }}</em>.
                                        </template>
                                        <em style="opacity: 0.5;" v-else>Escriba para Filtrar...</em>
                                        </template>
                                    </v-select> -->
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>


                

                

                <div class="row mt-1">
                    <div class="col">
                            <div class="tableFixHead" style="width:100%">
                                <table class="table table-bordered">
                                    <thead class="">
                                        <tr>
                                            
                                            <th style="background-color:#fff;" class="fixed" v-for="c in columnas" :key="c.label" v-show="c.show"></th>
                                            <th :colspan="td.productos.length" class="fixed outlineado background-salmon-3 text-center" v-for="td in tipo_despachos_seleccionados" :key="td.id"><span class="titulo_tabla_1">{{td.nombre}}</span></th>
                                            
                                        </tr>
                                        <tr>
                                            
                                            <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="c in columnas" :key="c.label" v-show="c.show"><span class="titulo_tabla_1">{{c.label}}</span></th>
                                            <th class="fixed-2 outlineado background-salmon-3 text-center" v-for="p in productos_seleccionados" :key="p.id"><span class="titulo_tabla_1">{{p.producto}}</span></th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="d in datos" :key="d.id" v-bind:class="{'background-red-2':d.restricciones != null,'background-light':d.seleccionado == 1}">
                                            
                                            <td class="text-center" v-for="c in columnas" :key="c.label" v-show="c.show" @click="d.seleccionado == 1?d.seleccionado= 0:d.seleccionado=1">
                                                



                                                <span v-if="c.tipo == 'numero'">
                                                    {{ devuelve_valor(d,c.path,c.tipo)| formatear_miles}}
                                                </span>

                                                <span v-if="c.tipo == 'string' || c.tipo == 'datetime' || c.tipo == 'time' || c.tipo == 'date'">
                                                    {{devuelve_valor(d,c.path,c.tipo)}}
                                                </span>

                                                

                                            </td>

                                            <td class="text-center" v-for="p in productos_seleccionados" :key="p.id">
                                                {{ devuelve_valor_producto(d,p.id)| formatear_miles}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                    </div>
                </div>

                <!-- <div class="row">
                    <div class="col">
                        <table class="table table-bordered">
                            <thead class="thead-blue">
                                <tr>
                                    <th class="text-center">TOTAL PESO INFORMADO (KG)</th>
                                    <th class="text-center">TOTAL PESO RECIBIDO (KG)</th>
                                    <th class="text-center">TOTAL PESO DISTRIBUCIÓN (KG)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="total_resultado">
                                    <td class="text-center">{{total_resultado.total_peso_informado | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_peso_recibido | formatear_miles}}</td>
                                    <td class="text-center">{{total_resultado.total_distribucion | formatear_miles}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div> -->

                <!-- <pre>{{mes}}</pre>
                <pre>{{anio}}</pre>
                <pre>{{inicio}}</pre>
                <pre>{{fin}}</pre>
                <pre>{{getDates}}</pre> -->
                <!-- <pre>{{fechas}}</pre> -->
                <!-- <pre>{{total_resultado}}</pre> -->
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        fechas:[],
        tipo_despachos:[],
        tipo_despachos_seleccionados:[],
        tipo_despacho_ids:[],
        productos:[],
        productos_ids:[],
        empresas:[],
        empresas_ids:"",
        dependencias:[],
        dependencias_ids:[],
        url_excel:null,



        todos:true,
        columnas:[
            //{show:true,label:'Fecha Ticket',tipo:'datetime',path:'fecha_hora_ticket'},
            {show:true,label:'Fecha',tipo:'date',path:'fecha'}

        ],
        datos:[],
    }),
    mounted(){
        this.cargar_tipo_despachos();
    },
    methods:{
        async cargar_tipo_despachos(){
          await this.axios.get(`${this.api}/tipo_despachos`,this.cabeceras_json,).then(res=>{
                this.tipo_despachos = res.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            this.cargar_productos_despachos();
        },

        async cargar_productos_despachos(){
          await this.axios.get(`${this.api}/producto_despachos?limit=999999999`,this.cabeceras_json,).then(res=>{
                this.productos = res.data.data.data;
            }).catch(e=>{
                //console.log(e);
            });
            //this.cargar_empresas_despachos();
        },

        

        async cargar_empresas_despachos(){
            await this.axios.get(`${this.api}/empresas_despachos`,this.cabeceras_json).then((res)=>{
            this.empresas = res.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          this.cargar_dependencias_despachos();
        },

        async cargar_dependencias_despachos(){
            await this.axios.get(`${this.api}/sucursales_despachos`,this.cabeceras_json).then((res)=>{
            this.dependencias = res.data.data;
          }).catch((e)=>{
            //console.log(e);
          });
        },

        async filtrarProveedores(search){
          await this.axios.get(`${this.api}/empresas?nombre=${search}&tipo_empresa_ids=4&agrupada_en_null=not_null&limit=9999999999`,this.cabeceras_json).then((res)=>{
            this.proveedores = res.data.data.data
            ////console.log('res',res.data.data.data);
          }).catch((e)=>{
            //console.log(e);
          });
          ////console.log('search',search)
          ////console.log('col',col)
        },

        async cargar_datos(){
            if(this.fechas[0] != null && this.fechas[0] != undefined){
                let body = {
                    desde:this.fechas[0],
                    hasta:this.fechas[1],
                    tipo_despacho_ids:this.tipo_despachos_select,
                    empresas_ids:this.empresas_ids,
                    productos_ids:this.productos_select,
                    dependencias_ids:this.dependencias_ids,
                    fechas:this.getDates,
                    columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                        return {cabecera:c.label,path:c.path,tipo:c.tipo}
                    })
                }
                await this.axios.post(`${this.api}/reportes/despachos/producto`,body,this.cabeceras_json).then(res=>{
                    //console.log(res.data.data);
                    this.datos = res.data.data.data;
                    this.tipo_despachos_seleccionados = res.data.data.tipo_despachos
                    //this.total_resultado = res.data.data.total;
                    this.url_excel = res.data.data.url;
                }).catch(e=>{
                    //console.log(e);
                });
            }
            
        },

        async exportar_excel(){
            window.open(this.url_excel, '_blank');
            /* let body = {
                desde:this.fechas[0],
                hasta:this.fechas[1],
                mps_id:this.mps_id,
                empresas_id:this.empresas_id,
                destinos_id:this.destinos_id,
                especies_id:this.especies_id,
                agrupar_empresa:this.agrupar_empresa,
                agrupar_sucursal:this.agrupar_sucursal,
                columnas:this.columnas.filter(c => c.show == true && c.path != 'declaracion_jurada' && c.path != 'cam').map((c)=>{
                    return {cabecera:c.label,path:c.path}
                })
            };
            await this.axios.post(`${this.api}/reportes/personalizado_excel`,body,this.cabeceras_json).then((res)=>{
                this.url_excel = res.data.data.url;
                window.open(this.url_excel, '_blank');
                //console.log(this.url_excel,res.data);
            }).catch((e)=>{
                //console.log(e);
            }); */
        },

        async obtener_parametros_mp(){
            let body = {
                mp_tipos_id:this.mps_id
            }
            await this.axios.post(`${this.api}/reportes/personalizado/obtener_parametros_mp`,body,this.cabeceras_json).then((res)=>{
                this.mps_parametros = res.data.data
            }).catch((e)=>{
                console.log(e);
            })
        },

        devuelve_valor(item,path,tipo_dato){
          let keys = path.split('.');
          let valor = item;
          keys.forEach(k => {
                for (var key in valor) {
                  if(key == k){
                    valor = valor[key];
                  }
                }
                  
          });
          if(tipo_dato == 'datetime'){
            valor = this.$options.filters.fecha_hora(valor);
          }
          if(tipo_dato == 'date'){
            valor = this.$options.filters.fecha(valor);
          }
          if(tipo_dato == 'time'){
            valor = this.$options.filters.hora(valor);
          }
          return valor;
        },

        devuelve_valor_producto(item,producto_id){
          let valor = item.productos.find(p=>p.id == producto_id).kilos
          return valor;
        },

        setearTodos(){
            this.columnas.forEach(c => {
                c.show = this.todos;
            });
        },

        abrirPdf(d){
            window.open(`${this.api_public}/guias/${d.url_guia}`, '_blank');
        },

        abrirDeclaracion(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.declaracion_jurada}`, '_blank');
        },

        abrirCam(d){
            window.open(`${this.api_public}/guias/archivos_adicionales/${d.cam}`, '_blank');
        },

        
        retornar_sucursales(){
            if(this.empresas_ids == null){
                return [];
            }
            return this.dependencias.filter(d => d.empresas_id == this.empresas_ids);
            //return this.dependencias.filter(p=>p.tipo_despacho_id == this.tipo_despacho_id);
        },

        
    },
    computed:{

        retornar_productos(){
            if(this.tipo_despacho_ids == null){
                return [];
            }
            return this.productos.filter(p=>this.tipo_despacho_ids.includes(p.tipo_despacho_id) ).sort(function (a, b) {
                if (a.tipo_despacho < b.tipo_despacho) {
                    return 1;
                }
                if (a.tipo_despacho > b.tipo_despacho) {
                    return -1;
                }
                // a must be equal to b
                return 0;
            });
            //return this.productos.filter(p=>p.tipo_despacho_id == this.tipo_despacho_id);
        },

        tipo_despachos_select(){
            if(this.tipo_despacho_ids.length == 0){
                return this.tipo_despachos.map(i => i.id)
            }
            return this.tipo_despacho_ids;
        },

        productos_select(){
            if(this.productos_ids.length == 0){
                return this.productos.map(i => i.id)
            }
            return this.productos_ids;
        },

        mps_parametros_seleccionados(){
            let array = [];
            let parametros = []
            
            this.mps_parametros.forEach(mp => {
                mp.analisis.forEach(a => {
                    a.parametros.forEach(p => {
                        if(p.check){
                            parametros.push(p);
                        }
                    });
                });
            });
            return parametros;
        },

        productos_seleccionados(){
            let array = [];
            this.tipo_despachos_seleccionados.forEach(element => {
                array = array.concat(element.productos);
            });
            return array;
        },

        getDates() {
            var dateArray = [];
            var currentDate = this.$moment(this.fechas[0]);
            var stopDate = this.$moment(this.fechas[1]);
            
            //this.$moment(this.fin);
            while (currentDate <= stopDate) {
                dateArray.push( this.$moment(currentDate).format('YYYY-MM-DD') )
                currentDate = this.$moment(currentDate).add(1, 'days');
            }
            return dateArray;
        },

        ...mapState(['api','api_public','cabeceras_json','token'])
    }
}
</script>
<style>
.tableFixHead          { overflow: auto; height: 600px; border: 1px solid rgb(212, 212, 212);}
/*.tableFixHead thead th { position: sticky; top: 0; z-index: 100; }*/

.fixed{
    position: sticky; 
    top: 1px; 
    z-index: 10;
    height: 43px;
}
.fixed-2{
    position: sticky; top: 43px; z-index: 10;
}
.outlineado{
    outline: 1px solid rgb(17, 15, 15);
}

/* Just common table stuff. Really. */
table  { border-collapse: collapse; width: 100%; }
th, td { padding: 8px 16px; }
/*th     { background:#427391; color:#fff }*/
.margen-1{
    margin: 0em 0.5em;
}

</style>